import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { BlockService } from '../../services/block-service/block.service';
import { ActivatedRoute } from '@angular/router';
import { EThemeName, ThemeService } from '@wind-log_library/fe-component-library';
import { Observable, ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-tclass-filter',
    templateUrl: './tclass-filter.component.html',
    styleUrls: ['./tclass-filter.component.scss'],
    standalone: false
})
export class TclassFilterComponent implements OnInit, OnChanges, OnDestroy {
    @Input() resetFilter;
    @Input() view;
    @Input() init;
    @Input() offsetRight = true;
    @Input() initialTClasses = null;
    @Output() optionChanged = new EventEmitter<any>();
    @Output() filterUpdated = new EventEmitter<any>();
    public toggle = false;
    public tclassList = [];
    public tclassSelectedList = [];
    private unsubscriber = new ReplaySubject();

    public selectAllTClass = true;

    public durationFilterOptions = [
        { id: 1, description: 'LOGBOOK.TURBINE.FILTER.ALL', value: 0 },
        { id: 2, description: '6+ hours', value: 6 },
        { id: 3, description: '12+ hours', value: 12 },
        { id: 4, description: '24+ hours', value: 24 }
    ];
    public selectedDurationFilter;
    public selectedCodeFilter = '';
    public hideLogsFilter = '';
    public exceptions = [];
    public IsHideLogsFilter = false;
    public theme$: Observable<EThemeName>;

    constructor(public blockService: BlockService, private route: ActivatedRoute, private themeService: ThemeService, private translate: TranslateService) {}

    ngOnInit() {
        this.translate.get(['LOGBOOK.TURBINE.FILTER.ALL', 'LOGBOOK.TURBINE.CREATE_POPUP.HOUR']).subscribe(translations => {
            this.durationFilterOptions = [
              { id: 1, description: translations['LOGBOOK.TURBINE.FILTER.ALL'], value: 0 },
              { id: 2, description: `6+ ${translations['LOGBOOK.TURBINE.CREATE_POPUP.HOUR']}`, value: 6 },
              { id: 3, description: `12+ ${translations['LOGBOOK.TURBINE.CREATE_POPUP.HOUR']}`, value: 12 },
              { id: 4, description: `24+ ${translations['LOGBOOK.TURBINE.CREATE_POPUP.HOUR']}`, value: 24 }
            ];
          });
        
        this.theme$ = this.themeService.getTheme();
        this.tclassList = JSON.parse(JSON.stringify(this.blockService.blocksHelper.tclasses));
        this.route.queryParams.pipe(takeUntil(this.unsubscriber)).subscribe((response: any) => {
            if (response.filter) {
                this.tclassList
                    .filter((t) => t.id === response.filter || t.tcu === response.filter.split('.')[0])
                    .map((t) => (t.selected = true));
                this.tclassSelectedList = this.resetFilter || this.tclassSelectedList.length === 0  ? this.tclassList.filter((t) => t.selected).map((t) => t.id) : this.tclassSelectedList;
                this.selectAllTClass = false;
            } else {
                if (this.initialTClasses) {
                    this.tclassList.map((t) => {
                        if (this.initialTClasses.indexOf(t.id) > -1) {
                            t.selected = true;
                        }
                        return t;
                    });
                    this.selectAllTClass = false;
                } else {
                    this.tclassList.map((t) => (t.selected = true));
                }
                this.tclassSelectedList = this.resetFilter || this.tclassSelectedList.length === 0 ? this.tclassList.filter((t) => t.selected).map((t) => t.id) : this.tclassSelectedList;
            }
            setTimeout(() => {
                this.filterUpdated.emit([
                    this.tclassSelectedList,
                    this.selectedDurationFilter,
                    this.selectedCodeFilter,
                    this.hideLogsFilter,
                    this.exceptions
                ]);
            }, 100);
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!this.init && changes.resetFilter) {
            changes.resetFilter.currentValue ? this.resetFilterValues() : null;
        }
    }

    updateFilterValues(value?: any) {
        this.optionChanged.emit(true);
        if (value && value.tcu === value.id) {
            this.tclassList.filter((t) => t.tcu === value.tcu).map((t) => (t.selected = value.selected));
        }
        this.tclassSelectedList = this.tclassList.filter((t) => t.selected).map((t) => t.id);
        setTimeout(() => {
            this.filterUpdated.emit([ this.tclassSelectedList, this.selectedDurationFilter, this.selectedCodeFilter, this.hideLogsFilter, this.exceptions]);
        }, 10);
    }

    private resetFilterValues() {
        this.selectAllTClass = true;
        this.tclassList.map((t) => (t.selected = true));
        this.tclassSelectedList = this.tclassList.filter((t) => t.selected).map((t) => t.id);
        this.selectedDurationFilter = this.durationFilterOptions[0];
        this.selectedCodeFilter = '';
        this.hideLogsFilter = '';
        this.exceptions = [];
        // setTimeout(() => {
        //     this.filterUpdated.emit([ this.tclassSelectedList, this.selectedDurationFilter, this.selectedCodeFilter ]);
        // }, 10);
    }

    public toggleSelectAll() {
        this.selectAllTClass = !this.selectAllTClass;
        this.tclassList.map((t) => (t.selected = this.selectAllTClass));
        this.updateFilterValues();
    }

    public toggleDropdown() {
        this.toggle = !this.toggle;
    }

    public closeDropdown() {
        this.toggle = false;
        // this.tclassSelectedList = this.tclassList.filter((t) => t.selected).map((t) => t.id);
        // setTimeout(() => {
        //     this.filterUpdated.emit([ this.tclassSelectedList, this.selectedDurationFilter, this.selectedCodeFilter ]);
        // }, 10);
    }

    public onDropdownSelected(option: any) {
        option.class.selected = !option.class.selected;
    }

    public defaultValues() {
        this.selectedCodeFilter = '';
        this.hideLogsFilter = '';
        this.exceptions = [];
        this.selectedDurationFilter = this.durationFilterOptions[0];
        this.selectAllTClass = true;
        this.tclassList.map((t) => (t.selected = true));
        this.updateFilterValues();
    }

    public addExceptions(){
        this.exceptions.push({id:this.exceptions.length + 1, value: ''});
    }

    public onKeyup(event: KeyboardEvent) {
        const inputValue = (event.target as HTMLInputElement).value;
        if(inputValue !== ''){
            this.IsHideLogsFilter = true;
        }else {
            this.IsHideLogsFilter = false;
            this.exceptions = [];
        }
    }

    public deleteException(index: number) {
        this.exceptions.splice(index,1);
        this.updateFilterValues();
    }

    public onDropdownSingleSelected(option: any) {
        this.tclassList.map((t) => (t.selected = false));
        this.selectAllTClass = false;
        option.class.selected = true;
        this.tclassSelectedList = [ option.class._id ];
        this.updateFilterValues();
    }

    ngOnDestroy(): void {
        this.unsubscriber.next(true);
        this.unsubscriber.complete();
    }
}
